import FacebookPixel from './FacebookPixel';

export const FBQ = new FacebookPixel();
